import fetch from '@api/fetchers';
import { HOST_TYPE, getHost } from '@utils/api-helper/host';

const defaultHost = getHost();

export const fetchStoreFilters = (goalUID) =>
  fetch(`${defaultHost}v1/store/sku/filters?goal_uid=${goalUID}`);

export const getStoreListingEndpoint = (goalUID, next = 0) =>
  `v1/aggregator/store/feed?goal_uid=${goalUID}&next=${next}&limit=12`;

export const fetchStoreListings = (goalUID) =>
  fetch(`${defaultHost}${getStoreListingEndpoint(goalUID)}`);

export const fetchGoalInfo = (goalUID) =>
  fetch(`${defaultHost}v1/topology/users/${goalUID}/self/`);

export const fetchDigitalNotesDetails = (notesUID) =>
  fetch(`${defaultHost}v1/uploads/notes-entity/details/?uid=${notesUID}`);

export const fetchPlusBottomBannerDetails = (goalUID) =>
  fetch(`${defaultHost}v1/topology/${goalUID}/welcome_feed/?limit=10`);

export const fetchPreSubNotesDetails = (notesUID) => {
  return fetch(`v1/store_combo/pre_sub/${notesUID}/details`);
};

export const fetchPostSubNotesDetails = (notesUID) => {
  return fetch(`v1/store_combo/post_sub/${notesUID}/details`);
};

export const fetchUserProfileInfo = (goalUID) => {
  return fetch(`v2/subscriptions/user/profile/?goal_uid=${goalUID}`, {
    hostType: HOST_TYPE.BACKEND_API_HOST
  });
};
